(function () {
  function productHandle(href) {
    if (!href) return null;
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function cardLinks(root) {
    return Array.prototype.slice.call(root.querySelectorAll('a[href*="/products/"]'));
  }

  function hideEmptyWrapper(recEl) {
    var wrapper =
      recEl.closest('.xo-product-info-content__complementary') ||
      recEl.closest('[id^="shopify-section-"]');
    if (wrapper) wrapper.setAttribute('hidden', 'hidden');
  }

  // <xo-product-recommendations> fetches its own contents the first time it
  // enters the viewport. Judging it before that point is not just early, it is
  // fatal: hiding the wrapper removes the element's box, so it can never
  // intersect, so it never fetches, so it stays empty for good. That is what
  // was happening on every desktop PDP -- the 4s fallback fired while the block
  // was still below the fold, and the related-products row was lost entirely.
  //
  // So: wait until the shopper could actually see it. If they never scroll that
  // far, there is nothing to tidy anyway.
  function whenSeen(el, callback) {
    if (typeof IntersectionObserver !== 'function') { callback(); return; }
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          observer.disconnect();
          callback();
          return;
        }
      }
    }, { rootMargin: '800px 0px' });
    observer.observe(el);
  }

  function settle(recEl, callback) {
    var settledOnce = false;
    var fallbackId = null;
    // Whichever path settles first cancels the other, so neither the observer nor the
    // fallback timer outlives the work. Previously the timer handle was discarded,
    // so on the normal path (observer wins in ~200-600ms) the timeout still sat in the
    // queue for the full duration holding recEl and callback alive.
    function finish() {
      if (settledOnce) return;
      settledOnce = true;
      observer.disconnect();
      if (fallbackId !== null) {
        clearTimeout(fallbackId);
        fallbackId = null;
      }
      callback();
    }
    var observer = new MutationObserver(finish);
    observer.observe(recEl, { childList: true, subtree: true });
    // Fallback in case the fetch never populates content (network error, no recs).
    // Measured from first intersection, not from DOMContentLoaded, so a slow
    // network gets the same grace period a fast one does.
    fallbackId = setTimeout(finish, 6000);
  }

  // The fetch lands in one mutation but the carousel keeps rearranging itself
  // afterwards, so give it one more frame before counting the cards.
  function judge(recEl, done) {
    whenSeen(recEl, function () {
      settle(recEl, function () {
        requestAnimationFrame(function () { done(); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var complementary = document.querySelector(
      '.xo-product-info-content__complementary xo-product-recommendations'
    );
    var related = Array.prototype.slice
      .call(document.querySelectorAll('xo-product-recommendations'))
      .filter(function (el) { return el !== complementary; })[0] || null;

    if (!complementary && !related) return;

    if (complementary) {
      judge(complementary, function () {
        if (!complementary.querySelector('a[href*="/products/"]')) {
          hideEmptyWrapper(complementary);
        }
      });
    }

    if (!related) return;

    // Judged independently of the complementary block. It sits lower on the
    // page, so by the time it is in view the complementary handles are already
    // known -- and if that block never loaded, there is simply nothing to
    // de-duplicate against.
    judge(related, function () {
      if (!related.querySelector('a[href*="/products/"]')) {
        hideEmptyWrapper(related);
        return;
      }

      if (complementary) {
        var complementaryHandles = cardLinks(complementary)
          .map(function (a) { return productHandle(a.getAttribute('href')); })
          .filter(Boolean);

        if (complementaryHandles.length) {
          cardLinks(related).forEach(function (a) {
            var handle = productHandle(a.getAttribute('href'));
            if (handle && complementaryHandles.indexOf(handle) !== -1) {
              var slide = a.closest('xo-carousel-slide') || a.closest('div');
              if (slide) slide.remove();
            }
          });
        }
      }

      if (!related.querySelector('a[href*="/products/"]')) {
        hideEmptyWrapper(related);
      }
    });
  });
})();
